import { createSlice } from "@reduxjs/toolkit";

interface UpsellState {
  loading: boolean;
  failed: any;
  trans: any;
  feature: any;
  ofcQuery: any;
}

const initialState: UpsellState = {
  loading: true,
  failed: null,
  trans: null,
  feature: null,
  ofcQuery: {
    airline: [],
    locale: [],
  },
};

const upsellSlice = createSlice({
  name: "hold",
  initialState,
  reducers: {
    loading: (state) => {
      state.loading = true;
      state.failed = null;
    },

    failed: (state, action) => {
      state.loading = false;
      state.failed = action.payload;
    },
    transLoaded: (state, action) => {
      state.loading = false;
      // vigo sends the upstream booking query as an object; older backends
      // sent it pre-stringified.
      const feature = action.payload.feature;
      if (feature) {
        try {
          state.feature = typeof feature === "string" ? JSON.parse(feature) : feature;
        } catch {
          state.feature = feature;
        }
      }
      state.trans = action.payload.trans;
    },
    ofcQueried: (state, action) => {
      state.loading = false;
      state.ofcQuery[action.payload.query] = action.payload.res;
    },
  },
});

export const { failed, loading, transLoaded, ofcQueried } = upsellSlice.actions;

export default upsellSlice.reducer;
